import api from "@/api/trading/apiAccount";
import { formatDecimal } from "@/utils/order";

export default {
  namespaced: true,
  state() {
    return {
      userNo: "",
      sessionId: "",
      userState: false,
      userWallet: {
        avbl: 0,
        balance: 0,
      },
      packageInfo: {
        package: "",
        endDate: "",
        userLang: "",
      },
      userAuth: {
        pmPro: false,
        sm: false,
      },
      reCode: 0,
      unrealizePnl: 0,
      isMobile: false,
      duplicateCheck: false,
    };
  },
  mutations: {
    setUserNo(state, payload) {
      state.userNo = payload.user_id;
      state.sessionId = payload.session_id;
      state.packageInfo = {
        package: payload.package,
        endDate: payload.end_date,
        userLang: payload.user_lang,
      };
    },
    setUserAuth(state, payload) {
      const userLang = payload.user_lang;
      const totalPrice = payload.package;
      if (
        totalPrice < 3000 &&
        userLang != "MN" &&
        userLang != "VN" &&
        userLang != "MY" &&
        userLang != "ID" &&
        userLang != "IN" &&
        userLang != "PH" &&
        userLang != "TH" &&
        userLang != "CN"
      ) {
        state.userAuth.pmPro = false;
      } else {
        state.userAuth.pmPro = true;
      }

      if (totalPrice < 10000) {
        state.userAuth.sm = false;
      } else {
        state.userAuth.sm = true;
      }
      // console.log('userLang', userLang,'totalPrice', totalPrice,state.userAuth.sm,state.userAuth.pmPro);
    },
    setUserState(state, payload) {
      state.userState = payload;
    },
    setWalletInfo(state, payload) {
      state.userWallet = {
        avbl: formatDecimal(payload.avbl, 4),
        balance: formatDecimal(payload.balance, 4),
      };
    },
    setReCode(state, payload) {
      state.reCode = payload;
    },
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
    setDuplicateCheck(state, payload) {
      state.duplicateCheck =
        payload === ""
          ? 0
          : payload === "중복 로그인이 감지되었습니다."
          ? 1
          : 2;
    },
    setUnrealizePnl(state, payload) {
      // state.unrealizePnl = formatDecimal(payload, 4);

      const numValue = Number(payload);

      if (isNaN(numValue) || payload === null || payload === "") {
        // 데이터가 깨졌거나 NaN일 경우
        // 안전하게 0으로 초기화하거나, return을 써서 이전 PnL 값을 유지
        //  에러 방지하기 위해 0으로 세팅
        state.unrealizePnl = 0;
        return;
      }

      const formattedValue = formatDecimal(numValue, 4);

      state.unrealizePnl = isNaN(Number(formattedValue)) ? 0 : formattedValue;
    },
  },
  actions: {
    async getUserInfo({ commit }) {
      try {
        if (process.env.NODE_ENV === "development") {
          let results = {
            user_id: "re-1",
            session_id: "123456789",
            end_date: "2025-07-30",
            package: 10000,
            user_lang: "EN",
          };
          commit("setUserNo", results);
          commit("setUserAuth", results);
        } else {
          const response = await api.getUserInfo();
          if (response) {
            commit("setUserNo", response.results);
            commit("setUserAuth", response.results);
            commit("setDuplicateCheck", response.message);
          }
        }
      } catch (error) {
        return;
      }
    },
    async getDuplicateCheck({ state, commit }) {
      try {
        const body = { user_id: state.userNo, session_id: state.sessionId };
        const response = await api.getDuplicateCheck(body);
        if (response) {
          commit("setDuplicateCheck", response.message);
        }
      } catch (error) {
        commit("setDuplicateCheck", null);
        return;
      }
    },
    async fetchUserState({ state, commit }) {
      try {
        const response = await api.getUserState(state.userNo);
        if (response) {
          commit("setUserState", response?.results[0]?.status);
        }
      } catch (error) {
        return;
      }
    },
    async fetchUserWallet({ state, commit }) {
      try {
        const response = await api.getUserWallet(state.userNo);
        if (response) {
          commit("setWalletInfo", response.results[0]);
        }
      } catch (error) {
        return;
      }
    },
    async postStartTrading({ state, commit }) {
      try {
        const response = await api.postStartTrading(state.userNo);
        if (response) {
          commit("setReCode", response.reCode);
        }
      } catch (error) {
        return;
      }
    },
    async postChargeSeed({ state, commit }, seed) {
      try {
        const response = await api.postChargeSeed(state.userNo, seed);
        if (response) {
          commit("setReCode", response.reCode);
        }
      } catch (error) {
        return;
      }
    },
    async postResetUser({ state, commit }) {
      try {
        const response = await api.postResetUser(state.userNo);
        if (response) {
          commit("setReCode", response.reCode);
        }
      } catch (error) {
        return;
      }
    },
  },
};
